import React, { useCallback, useState, useRef } from "react";
import { testi } from "../../../data/data";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { FaStar } from "react-icons/fa";
import ImageViewer from "react-simple-image-viewer";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

const Abouttest = () => {

  const [currentImage, setCurrentImage] = useState(0);
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const swiperRef = useRef(null); // Create a ref for the Swiper instance

  const openImageViewer = useCallback((index) => {
    setCurrentImage(index);
    setIsViewerOpen(true);
  }, []);

  const closeImageViewer = () => {
    setCurrentImage(0);
    setIsViewerOpen(false);
  };

  // Custom navigation buttons
  const handleNext = () => {
    if (swiperRef.current) {
      swiperRef.current.swiper.slideNext();
    }
  };

  const handlePrev = () => {
    if (swiperRef.current) {
      swiperRef.current.swiper.slidePrev();
    }
  };

  return (
    <div id="testimonials" className="w-[100vw] bg-secondary-gray py-[30px] sm:py-[4.167vw] scroll-mt-[90px] lg:scroll-mt-[140px]">

      <div className="max-w-[90vw] sm:max-w-[85vw] mx-auto">
        <div className="text-[22px] lg:text-36 font-urbanist font-semibold mb-[5vh]">
          Testimonials
          <hr className='h-1 w-16 lg:w-20 mx-auto bg-red-600' />
        </div>
        <Swiper
          ref={swiperRef} // Attach the ref to the Swiper
          slidesPerView={2}
          spaceBetween={10}
          breakpoints={{
            640: { slidesPerView: 2 },
            740: { slidesPerView: 3 },
            1024: { slidesPerView: 4 },
            1440: { slidesPerView: 4 },
          }}
          loop={true}
          navigation={false} // Disable default navigation
          pagination={{ clickable: true }}
          modules={[Navigation, Pagination]}
          className="w-full flex justify-center items-center"
        >
          {testi.map((testimonial, index) => (
           <SwiperSlide key={index} className="relative cursor-pointer">
              <div className="flex bg-white min-[300px] shadow-md lg:min-h-[20.938vw] h-auto flex-col justify-start items-center">
                <div className="h-full w-full mx-auto rounded-lg p-1 lg:p-[1.667vw]">
                  <div className="flex flex-col justify-center items-center text-[#062A3F]">
                    <div className="flex flex-col justify-center items-center">
                    {/* Avatar Image */}
                      <div className="w-10 h-10 rounded-full mb-1">
                        <img
                          src={testimonial.image || "https://via.placeholder.com/64"}
                          alt={testimonial.name}
                          className="w-full h-full object-cover rounded-full cursor-pointer"
                          onClick={() => openImageViewer(index)}
                        />
                      </div>
                      <p className="text-[14px] lg:text-[0.8vw] font-urbanist mb-2 lg:mb-[0.4vw]">
                        {testimonial.item}
                      </p>
                      <p className="text-[13px] lg:text-18  md:text-justify">
                        {testimonial.para}
                      </p>
                    </div>
                    <div className="flex flex-col items-center gap-y-1 lg:gap-y-[0.2vw] mt-2 lg:mt-[0.5vw]">
                    <div className="flex flex-col justify-center items-center ">
                      <p className="text-[16px] lg:text-24 font-semibold lg:font-bold font-urbanist">
                        {testimonial.name}
                      </p>
                    </div>
                     {/* Star Rating */}
                     <div className="flex mb-3 text-yellow-400">
                      {[...Array(5)].map((_, i) => (
                        <FaStar key={i} />
                      ))}
                    </div>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Custom Navigation Buttons */}
        <div className="flex justify-center gap-x-2 lg:gap-x-[1.51vw] mt-4">
          <button onClick={handlePrev} className="bg-primary-red text-white p-2 rounded-full">
            <IoIosArrowBack />
          </button>
          <button onClick={handleNext} className="bg-primary-red text-white p-2 rounded-full">
          <IoIosArrowForward />
          </button>
        </div>

        {isViewerOpen && (
          <ImageViewer
            src={testi.map(testimonial => testimonial.image || "https://via.placeholder.com/64")}
            currentIndex={currentImage}
            disableScroll={true}
            closeOnClickOutside={true}
            onClose={closeImageViewer}
            closeComponent={true}
            backgroundStyle={{
              zIndex: 99999,
              backgroundColor: "rgba(0, 0, 0, 0.9)",
            }}
          />
        )}
      </div>
    </div>
  );
};

export default Abouttest;